import {
  MutationTree,
} from 'vuex';

import {
  ProfileMutationsTypeEnum,
} from '@/store/modules/profile/mutation-types';
import {
  ProfileState,
} from '@/store/modules/profile/types';
import {
  Profile,
} from '@/transformers/profile/types';

export const mutations: MutationTree<ProfileState> = {

  [ProfileMutationsTypeEnum.UPDATE_DATA]: (state: ProfileState, value: Profile) => {
    state.data = value;
  },

  [ProfileMutationsTypeEnum.UPDATE_STATE]: (state: ProfileState, value: boolean) => {
    state.isLoaded = value;
  },

};
